import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import recreateOnNavigation from '../../HOC/recreateOnNavigation';
import Layout from './Layout';

const LayoutWithStickyTimer = ({ sticky, stickyTimer, ...otherProps }) => {
  const [isIntersecting, outerRef] = useInView({});
  const [isSticky, setIsSticky] = useState(sticky);

  useEffect(
    () => {
      if (isIntersecting && sticky && !!stickyTimer) {
        setIsSticky(true);
        const timer = setTimeout(() => {
          setIsSticky(false);
        }, stickyTimer);

        return () => {
          clearTimeout(timer);
        };
      }
    },
    [isIntersecting, stickyTimer, sticky]
  );

  return <Layout {...otherProps} sticky={isSticky} ref={sticky ? outerRef : null} />;
};

LayoutWithStickyTimer.propTypes = {
  sticky: PropTypes.bool,
  stickyTimer: PropTypes.number
};

LayoutWithStickyTimer.defaultProps = {
  sticky: false,
  stickyTimer: 0
};

export default recreateOnNavigation(LayoutWithStickyTimer);
